















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ConfirmDialogModule from '../../modules/ConfirmDialogModule';
import ConfirmDialog from './ConfirmDialog.vue';

@Component({   
  components: {  
    ConfirmDialog
  } 
})
export default class ShowConfirm extends Vue {  
  protected confirmDialogStore: ConfirmDialogModule = getModule(ConfirmDialogModule, this.$store);
  protected message: string = '';
  protected title: string = '';
  protected show: boolean = false;  
  protected width: number = 500;
  protected okButtonText: string = '';
  protected cancelButtonText: string = '';
  protected onConfirmFunc: Function | null = null;
  protected isNavigatingAwayConfirm: boolean = false;  
   
  constructor() {
    super();     
  }
 
  protected get dialogShow(): boolean {
    return this.confirmDialogStore.showStatus;
  }

  protected onConfirm(value: boolean): void {
    if(this.onConfirmFunc) {
      this.onConfirmFunc(value);
    }  
    if(!value) {
      this.show = false;
    }      
    this.confirmDialogStore.reset();
  }

  @Watch('dialogShow')
  protected changeStatus(toggle: boolean): void {
    if(toggle){
      this.show = toggle;
      this.message = this.confirmDialogStore.message;
      this.width = this.confirmDialogStore.width; 
      this.onConfirmFunc = this.confirmDialogStore.onConfirmFunc;
      this.title = this.confirmDialogStore.title;
      this.okButtonText = this.confirmDialogStore.okButtonText;
      this.cancelButtonText = this.confirmDialogStore.cancelButtonText;
    }    
  }
}
